export const getInvite = state => state.invite.invite;
export const getIsLoadingInvite = state => state.invite.isLoading;
export const getInviteError = state => state.invite.errorMessage;
